import React, { FunctionComponent } from 'react';

import { Link as OrbLink } from '@yandex-360/orb-components/dist/components/Link';
import cn from 'classnames';

import css from './index.css';

type OrbLinkProps = Omit<React.ComponentProps<typeof OrbLink>, 'children'> & {
    children?: React.ReactNode;
};

const Link: FunctionComponent<OrbLinkProps> = (props) => {
    const { className, view, children, ...otherProps } = props;
    return (
        <OrbLink className={cn(css.Link, className)} view={view || 'default'} {...otherProps}>
            {children}
        </OrbLink>
    );
};

export default Link;
